import {
    DialogButtonTypesEnum,
    DialogConfigInterface, RadioGroupOptionInterface,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from '../../../app/shared/components';
import {
    BrokerGetOutputModel,
    BrokerSearchExtendedInputModel,
    BrokerSearchExtendedOutputItemModel,
    BrokerSearchExtendedType,
    BrokerUpdateInputModel, ExecutionBrokerStatusEnum, RouteSetUpdateInputModel,
    RouteUpdateInputModel
} from '@spa/api';
import {FilterControlInterface} from 'appShared/interfaces';
import {
    BaseControl,
    CheckboxControl,
    Helper, RadioGroupControl,
    SelectControl
} from 'appShared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {Validators} from '@angular/forms';
import {ConfirmationData} from 'appEntries/panel/classes';

export const PanelOrderRoutesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getBrokerIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getBrokerNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getBrokerCodeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getRouteDisplayNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getRouteSubDestinationSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getHasRouteSetSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: BrokerSearchExtendedOutputItemModel.getRouteSetsSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelOrderRoutesDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Broker ID',
            selector: BrokerSearchExtendedOutputItemModel.getBrokerIdSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Broker Name',
            selector: BrokerSearchExtendedOutputItemModel.getBrokerNameSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Broker Code',
            selector: BrokerSearchExtendedOutputItemModel.getBrokerCodeSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Display Name',
            selector: BrokerSearchExtendedOutputItemModel.getRouteDisplayNameSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Sub Dest',
            selector: BrokerSearchExtendedOutputItemModel.getRouteSubDestinationSelector(),
            sortable: false
        }),

        new ReportTableColumn({
            label: 'Included In Set',
            selector: BrokerSearchExtendedOutputItemModel.getHasRouteSetSelector(),
            sortable: false
        }),
        new ReportTableColumn({
            label: 'Set Name',
            selector: BrokerSearchExtendedOutputItemModel.getRouteSetsSelector(),
            sortable: false
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
};

export const PanelOrderRoutesFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: BrokerSearchExtendedInputModel.getBrokerIdsSelector(),
            placeholder: 'Execution Broker',
            controls: [
                new SelectControl({
                    name: BrokerSearchExtendedInputModel.getBrokerIdsSelector(),
                    value: null,
                    placeholder: 'Execution Broker',
                    validators: [],
                    multiple: true,
                    componentType: ComponentTypesEnum.Select,
                    options: []
                })
            ],
            sortIndex: 1
        },
        {
            name: BrokerSearchExtendedInputModel.getSearchTypeSelector(),
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: BrokerSearchExtendedInputModel.getSearchTypeSelector(),
                    value: -1,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: -1
                        },
                        {
                            label: Helper.textsHelper().getBrokerSearchExtendedInputTypeName(BrokerSearchExtendedType.Route),
                            value: BrokerSearchExtendedType.Route
                        },
                        {
                            label: Helper.textsHelper().getBrokerSearchExtendedInputTypeName(BrokerSearchExtendedType.RouteSet),
                            value: BrokerSearchExtendedType.RouteSet
                        }
                    ]
                })
            ],
            sortIndex: 2
        },
        {
            name: BrokerSearchExtendedInputModel.getRouteDisplayNameSelector(),
            placeholder: 'Display Name',
            controls: [
                new BaseControl({
                    name: BrokerSearchExtendedInputModel.getRouteDisplayNameSelector(),
                    value: null,
                    placeholder: 'Display Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 3

        }
    ];
};

export interface BrokerFormControlsInterface {
    name: BaseControl;
    code: BaseControl;
}

export const BrokerFormControls = (): BrokerFormControlsInterface => {
    return {
        name: new BaseControl({
            name: BrokerUpdateInputModel.getNameSelector(),
            value: '',
            placeholder: 'Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        }),
        code: new BaseControl({
            name: BrokerUpdateInputModel.getCodeSelector(),
            value: '',
            placeholder: 'Code',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        })
    };
};

export interface RouteFormControlsInterface {
    broker: BaseControl;
    displayName: BaseControl;
    subDestination: BaseControl;
}


export const RouteFormControls = (): RouteFormControlsInterface => {
    return {
        broker: new SelectControl({
            name: RouteUpdateInputModel.getExecutionBrokerIdSelector(),
            value: null,
            placeholder: 'Execution Broker',
            validators: [Validators.required],
            options: [],
            componentType: ComponentTypesEnum.Select,
        }),
        displayName: new BaseControl({
            name: RouteUpdateInputModel.getDisplayNameSelector(),
            value: '',
            placeholder: 'Display Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        }),
        subDestination: new BaseControl({
            name: RouteUpdateInputModel.getSubDestinationSelector(),
            value: '',
            placeholder: 'Sub Destination',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        })
    };

};
export const RouteSetFormControlsRouteArraySelector = 'RouteSetFormControlsRouteArraySelector';
export const RouteFormControlsRouteArraySelector = 'RouteFormControlsRouteArraySelector';
export const BrokerFormControlsBrokerSelector = 'BrokerFormControlsBrokerSelector';
export const BrokerFormControlsCurrencySelector = 'BrokerFormControlsCurrencySelector';

export const RouteSetFormControlsRouteIsRequired = 'At least one route';

export interface RouteSetFormControlsInterface {
    broker: BaseControl;
    name: BaseControl;
    routes: CheckboxControl[];
}

export const RouteSetFormControls = (): RouteSetFormControlsInterface => {
    return {
        broker: new SelectControl({
            name: RouteSetUpdateInputModel.getExecutionBrokerIdSelector(),
            value: null,
            placeholder: 'Execution Broker',
            validators: [Validators.required],
            options: [],
            componentType: ComponentTypesEnum.Select,
        }),
        name: new BaseControl({
            name: RouteSetUpdateInputModel.getNameSelector(),
            value: '',
            placeholder: 'Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,
        }),
        routes: []
    };
};

export interface BrokerAssociationFormControlsInterface {
    currency?: SelectControl;
    brokers: RadioGroupControl;
}

export const BrokerAssociationFormControls = (includeCurrency = false): BrokerAssociationFormControlsInterface => {
    const controls: BrokerAssociationFormControlsInterface = {
        brokers: new RadioGroupControl({
            name: BrokerFormControlsBrokerSelector,
            value: null,
            placeholder: 'Execution Brokers',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.RadioGroup,
            invalid: false,
            disabled: false,
            errors: [],
            options: []
        })
    };

    if (includeCurrency) {
        controls.currency = new SelectControl({
            name: BrokerFormControlsCurrencySelector,
            value: null,
            placeholder: 'Account Base Currency',
            validators: [Validators.required],
            options: [],
            componentType: ComponentTypesEnum.Select,
        });
    }

    return controls;
};

export interface RouteSetAssociationFormControlsInterface {
    routeSets: CheckboxControl[];
}

export const RouteSetAssociationFormControls = (): RouteSetAssociationFormControlsInterface => {
    return {
        routeSets: []
    };
};

export interface RouteAssociationFormControlsInterface {
    routes: CheckboxControl[];
}

export const RouteAssociationFormControls = (): RouteAssociationFormControlsInterface => {
    return {
        routes: []
    };
};


export const AddBrokerDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const ExecutionBrokerStatusesControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: BrokerGetOutputModel.getStatusSelector(),
        value: null,
        placeholder: 'Status',
        validators: [
            Validators.required
        ],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: []
    });
};

export const BrokerStatusControlOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getOrderRoutesBrokerStatusName(
                ExecutionBrokerStatusEnum.InActive
            ),
            value: ExecutionBrokerStatusEnum.InActive,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getOrderRoutesBrokerStatusName(
                ExecutionBrokerStatusEnum.Active
            ),
            value: ExecutionBrokerStatusEnum.Active,
            color: ColorCodesEnum.Primary
        },
    ];
};

export const AddRouteDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const AddRouteSetDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};


export const ConfirmInactivateBrokerData = (): ConfirmationData => {
    return new ConfirmationData(
        null,
        '<div class="mb-2 d-flex justify-content-center" style="font-size: 3em"><i class="fa fa-exclamation-circle d-block text-secondary" ></i></div><br/>You are about to change the status of the executing broker to “Inactive.” This action will impact all associated accounts and account groups, which will be updated accordingly by removing all routes associated with the broker from their profiles. Do you want to proceed?',
        [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                customText: 'Yes, Inactivate'
            }
        ],
        true
    );
};
